<div class="container">

    <section class='header'>

        <mat-toolbar color='primary' fxLayoutAlign="space-between">
            <div>
                <mat-icon style='margin-top:10px; font-size:.9em;'>sports_basketball</mat-icon>
                <div style='display:inline-block; margin-left:10px;'>
                    {{ local_title }}
                </div>
            </div>

            <button class="button-close" mat-raised-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar>

    </section>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>sports_basketball</mat-icon>
                    <div>Staff</div>
                </ng-template>

                <div class='tab-content-id'>

                    <mat-form-field class="name-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.name" placeholder="Nome" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                            O nome é obrigatório
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="title-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.title" placeholder="Título" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.title.hasError('required')">
                            O Título é obrigatório.
                        </mat-error>
                    </mat-form-field>


                    <mat-form-field class="email-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.email" placeholder="Email" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.email.hasError('required')">
                            O Email é obrigatório.
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="state-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.state" placeholder="Estado" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.state.hasError('required')">
                            O Estado é obrigatório.
                        </mat-error>
                    </mat-form-field>


                    <mat-form-field class="country-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.country" placeholder="Pais" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.country.hasError('required')">
                            O Pais é obrigatório.
                        </mat-error>
                    </mat-form-field>

                </div>

            </mat-tab>

        </mat-tab-group>

    </form>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <div [ngClass]="{hidden: !spinner}">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
        <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
    </div>

</div>